import { render } from "./AppDescription.vue?vue&type=template&id=c918ef4a&scoped=true"
import script from "./AppDescription.vue?vue&type=script&lang=js"
export * from "./AppDescription.vue?vue&type=script&lang=js"

import "./AppDescription.vue?vue&type=style&index=0&id=c918ef4a&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c918ef4a"]])

export default __exports__